import React from 'react'
import { FlatButton } from 'material-ui'
import Delete from 'material-ui/svg-icons/action/delete'

export default (props) => (
  <FlatButton
    secondary
    icon={<Delete />}
    style={{ minWidth: 0 }}
    {...props}
  />
)
